<script setup>
import { ref } from 'vue'
import {
  TooltipRoot,
  TooltipTrigger,
  TooltipContent,
  TooltipArrow,
  TooltipProvider
} from 'radix-vue'
import { CircleHelp } from 'lucide-vue-next'
import { TOOLTIP_ICON_COLOR } from '@/lib/colors'
import { detectDeviceType } from '@/lib/utils'

const props = defineProps({
  content: String,
  side: {
    type: String,
    default: 'bottom',
    validator: (value) => ['bottom', 'top'].includes(value)
  },
  size: {
    type: Number,
    default: 18
  }
})

const isMobile = detectDeviceType() === 'mobile'
const open = ref(false)

function handleMouseEnter() {
  if (!isMobile) {
    open.value = true
  }
}

function handleMouseLeave() {
  if (!isMobile) {
    open.value = false
  }
}

function toggleTooltip(e) {
  if (isMobile) {
    e.stopPropagation()
    open.value = !open.value
  }
}
</script>

<template>
  <TooltipProvider :delay-duration="0">
    <TooltipRoot v-model:open="open">
      <TooltipTrigger as-child>
        <button
          class="cursor-pointer"
          @click="toggleTooltip"
          @mouseenter="handleMouseEnter"
          @mouseleave="handleMouseLeave"
        >
          <CircleHelp :size="size" :color="TOOLTIP_ICON_COLOR" />
        </button>
      </TooltipTrigger>
      <TooltipContent
        :side="side"
        :align="'center'"
        class="bg-tooltip-1 z-999 text-sm shadow-lg p-3 text-white rounded-lg"
      >
        <TooltipArrow class="fill-tooltip-1" />
        <p v-if="content" class="max-w-[24ch]">{{ content }}</p>
        <slot></slot>
      </TooltipContent>
    </TooltipRoot>
  </TooltipProvider>
</template>
